export enum AccountSettingsTabs {
  General,
  GiveSettings,
  ApprovalLevels,
  Subscription,
  Payment,
  Resources,
  StandardPrograms,
}
